class ServerSystem extends Error {}

export default ServerSystem;



// WEBPACK FOOTER //
// ./src/errors/ServerSystem.ts